import React from 'react';
import styles from './style.module.css';
import { NotificationsButton } from '../../sideNavBar/sideNavBarButtons/notificationsButton';
import { CartButton } from '../../sideNavBar/sideNavBarButtons/cartButton';
import { MyOrdersButton } from '../../sideNavBar/sideNavBarButtons/myOrders';
import { WishlistButton } from '../../sideNavBar/sideNavBarButtons/wishlistButton';
import { ReferralButton } from '../../sideNavBar/sideNavBarButtons/referralButton';

export const DropdownMenu = () => {
  return (
    <div className={styles.dropdownMenu}>
      <NotificationsButton />
      <CartButton/>
      <MyOrdersButton/>
      <WishlistButton/>
      <ReferralButton/>
    </div>
  );
};